import React from 'react';
import './SignUp.css';
import NavBar from '../Components/NavBar';

const SignUp = () => {
    return(
        <div className>
        <NavBar></NavBar>
        <div className='padding'>
            <div className='signup-title'>Sign Up</div>
            <div className="margin">
            <div className='title'>Email</div>
            <input className='text-box'></input>
            <div className='title'>Password</div>
            <input className='text-box'></input>
            <button className='signup-button'>Sign Up</button>
            </div>
        </div>
        </div>
    );
}

export default SignUp;